import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { EnrollmentService } from '../../services/enrollment.service';
import { ListManagerService } from 'src/app/services/list-manager.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { MatAccordion } from '@angular/material/expansion';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { GuestService } from 'src/app/services/guest.service';
import { PersonalPreferenceService } from 'src/app/services/personal-preference.service';
import { ConstantsService } from 'src/app/services/constants.service';
import _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { ContactusComponent } from 'src/app/reusable-components/contactus/contactus.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { VariablesService } from 'src/app/services/variables.service';
import { LineitemService } from 'src/app/services/lineitem.service';
@Component({
    selector: 'app-guest',
    templateUrl: './guest.component.html',
    standalone: false
})
export class GuestComponent implements OnInit {
  enrollment;
  isSubmitting = false;
  isFormCompleted = false;
  isRegComplete: any;
  guests: any;
  maxGuests: any;
  programInfo: any;
  attendee: any;
  selectedGuest: any;
  isError: any;
  toBeDeleted: any;
  forms = [];
  hasGuestsAttending;
  DisabilityType;
  personalConsiderationsList;
  mealList;
  isNeedingDietaryConsiderations;
  suffixList;
  prefixList;
  guestTypes;
  isDeleting;
  minChildDate;
  guestTypesNoDollars;
  guestTypesWithDollars;
  guestCity; //GUEST_CITY
  charges = {
    Guest: null,
  };
  CCerror;
  payment;
  @ViewChildren(MatExpansionPanel) panels: QueryList<ElementRef>;

  constructor(
    private navigationService: NavigationService,
    public registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    private configurationService: ConfigurationService,
    private guestService: GuestService,
    private personalPreferenceService: PersonalPreferenceService,
    private constantsService: ConstantsService,
    public dialog: MatDialog,
    private variablesService: VariablesService,
    private lineItemService: LineitemService
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    this.attendee = this.registrationService.getAttendee({});
    this.hasGuestsAttending = this.attendee.$mtcHasGuestsAttending;
    this.guests = this.registrationService.getGuests({});
    this.listService.getCommonPrefixList().then(list => {
      this.prefixList = list;
    });
    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;
    });
    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;
      this.personalConsiderationsList.forEach(disability => {
        if(disability.name == "Hearing Impaired"){
          disability.name = "Deaf/Hard of Hearing"
        }
      });
    });
    this.listService.getSuffixList().then(list => {
      this.suffixList = list;
    });
      this.guestTypesNoDollars = [
        {display: 'Adult Guest (18+)', value: 11},   
        {display: 'Youth Guest (12-17)', value: 12},
        {display: 'Child Guest (6-11)', value: 13},
        {display: 'Young Child Guest (5 and under)', value: 14},
        {display: 'Guest Day Pass - Opening General Session with Keynote & Welcome Reception', value: 15},
        {display: 'Guest Day Pass - Final Night Concert & Party in the Park', value: 16}
      ];  
    // if(this.isRegComplete){
    //   this.guestTypesWithDollars = [
    //     // {display: 'Adult Guest (18+) - $550', value: 11},   
    //     // {display: 'Youth Guest (12-17) - $350', value: 12},
    //     // {display: 'Child Guest (6-11) - $250', value: 13},
    //     // {display: 'Young Child Guest (5 and under) - No Charge', value: 14},
    //     {display: 'Guest Day Pass - September 14 Opening General Session with Keynote & Welcome Reception - $250', value: 15},
    //     {display: 'Guest Day Pass - September 16 Final Night Concert & Party in the Park - $250', value: 16}
    //   ];
    // }else{
      this.guestTypesWithDollars = [
        {display: 'Adult Guest (18+) - $550', value: 11, disabled:this.isRegComplete},   
        {display: 'Youth Guest (12-17) - $350', value: 12,disabled:this.isRegComplete},
        {display: 'Child Guest (6-11) - $250', value: 13,disabled:this.isRegComplete},
        {display: 'Young Child Guest (5 and under) - No Charge', value: 14,disabled:this.isRegComplete},
        {display: 'Guest Day Pass - September 14 Opening General Session with Keynote & Welcome Reception - $250', value: 15,disabled:false},
        {display: 'Guest Day Pass - September 16 Final Night Concert & Party in the Park - $250', value: 16,disabled:false}
      ];
    //}
    if(this.isRegComplete){
    for (const key of _.keys(this.charges)) {
          this.lineItemService.getLineItemsGuest(key).subscribe({
            next: data => {
              this.charges[key] = _.reduce(data, (sum, n) => {
                return parseFloat(sum) + parseFloat(n);
              });
              },
                error: error => {
                  this.constantsService.ALERT_POLICY.CONTACT_SUPPORT
                }
          });
        }
    }

  }
  isNewGuest(guest){
    //console.log(guest.ExternalAttendeeKey);
    if(guest.ExternalAttendeeKey !== undefined){
      return false;
    }else{
      return true;
    }
  }
  addedNewGuestInRVS(){
    this.guests = this.registrationService.getGuests({});
      for(let guest of this.guests){
      if(guest.ExternalAttendeeKey === undefined){
        console.log(guest);
        console.log("returning true");
        return true;
        break;
      }
    }
    return false;
  }
  ngOnInit(): void {
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.maxGuests = this.programInfo.maxGuests;
    });
    // this.guestService.getGuestTypesList().then((gTypes: any) => {
    //   //console.log(gTypes);
    //   //this.guestTypes = gTypes;
     
    // });
    this.isNeedingDietaryConsiderations = this.personalPreferenceService.isNeedingDietaryConsiderations;
    if (this.guests.length > 0) {
      if (!this.areAnyGuestsSelected()) {
        this.selectGuest(_.first(this.guests));
      }
    }
    if (this.guests.length > 0) {
      this.attendee.$mtcHasGuestsAttending = true;
      this.guests.forEach(guest => {
        if(!guest.$mtcUUID){
          guest.$mtcUUID = Math.random();
        }
      });
    }
    if (this.guests.length === 0) {
    this.addGuest({});
    }

    // this.guestService.getChildMinDate().then(date=>{
    //   console.log(date);
    //   this.minChildDate = date;
    // });

  }
  checkpayment(){
    this.CCerror=undefined;
    if (this.attendee.$mtcHasGuestsAttending && this.isRegComplete){
      this.payment = this.registrationService.getPayment([]);

      let card = this.registrationService.getCreditCard(this.payment, 'Guest', undefined);
      if (!card || !card.ReferenceKey && card.MediaType === "CREDITCARD") {
        this.CCerror="Credit Card is required";
      }
    }
  }
  isChild(pax){
    return this.guestService.isChild(pax);
  }
  includes(arr, val) {
    return _.includes(arr, val);
  }

  considerationUpdate(consideration, guest) {
    let justadded = false;

    if (guest.DisabilityType === undefined) {
      guest.DisabilityType = [];
      guest.DisabilityType = this.registrationService.getDisabilities(guest, "");
    }

    if (!_.includes(guest.DisabilityType, consideration.code)) {
      guest.DisabilityType.push(consideration.code);
      justadded = true;
    }
    if (justadded === false && _.includes(guest.DisabilityType, consideration.code)) {
      let index = guest.DisabilityType.indexOf(consideration.code);
      if (index !== -1) {
        guest.DisabilityType.splice(index, 1);
      }
    }
  }

  /**
   * @function isAddGuestEnabled
   * @description Returns if guests is less then the max amount of guests.
   */
  isAddGuestEnabled() {
    return this.guests.length < this.maxGuests;
  }
  guestPAXTypeChange(){
    this.addedNewGuestInRVS();

    if(this.isRegComplete){
      for (const key of _.keys(this.charges)) {
            this.lineItemService.getLineItemsGuest(key).subscribe({
              next: data => {
                this.charges[key] = _.reduce(data, (sum, n) => {
                  return parseFloat(sum) + parseFloat(n);
                });
                },
                  error: error => {
                    this.constantsService.ALERT_POLICY.CONTACT_SUPPORT
                  }
            });
          }
      }
  }
  /**
   * @function addGuest
   * @description Sets if the attendee has guests attending to true then adds a new guest to the [RegistrationService](./app.RegistrationService.html)
   */
  addGuest(guest) {
    this.isFormCompleted = false;
    guest.$mtcUUID = Math.random();
    this.guests.push(guest);
    this.registrationService.addGuests(guest);
    this.selectGuest(guest);
    this.addedNewGuestInRVS();
    if(this.isRegComplete){
      for (const key of _.keys(this.charges)) {
            this.lineItemService.getLineItemsGuest(key).subscribe({
              next: data => {
                this.charges[key] = _.reduce(data, (sum, n) => {
                  return parseFloat(sum) + parseFloat(n);
                });
                },
                  error: error => {
                    this.constantsService.ALERT_POLICY.CONTACT_SUPPORT
                  }
            });
          }
      }
  }

  /**
   * @function selectGuest
   * @description Used for selecting a specific guest on the page.
   */
  selectGuest(guest) {
    this.guestService.selectGuest(guest);
    // _.each(this.guests, (item) => {
    //   let consideration = this.personalPreferenceService.hasConsiderations(item);
    //   if (item.$mtcHasConsiderations === undefined) {
    //     item.$mtcHasConsiderations = consideration;
    //   }
    // });
    this.selectedGuest = guest;
    return guest;
  }

  /**
   * @function getDisplayName
   * @description Returns the Preferred name for the guest or returns false.
   * @returns {String|Boolean}
   */
  getDisplayName(guest) {
    if (guest) {
      return guest.PreferredFirstName || guest.FirstName || "Guest";
    } else {
      return false;
    }
  }

  forward(form) {
    console.log(form);
    this.checkpayment();
    console.log(this.CCerror);
    this.isSubmitting = true;
    this.isFormCompleted = true;
    if ((form.valid || form.disabled) && !this.CCerror) {
      if (!this.attendee.$mtcHasGuestsAttending) {
        this.registrationService.removeGuests(this.guests);
      }
     
      this.guests.forEach((guest) => {
        guest.$mtcIsSelected = false;
        if(this.isRegComplete){
          if(guest.DietaryConsiderations && guest.$mtcAllergens){
            guest.DietaryConsiderations = guest.$mtcAllergens.join(', ') + ', ' + guest.DietaryConsiderations;
          } else if (guest.$mtcAllergens) {
            guest.DietaryConsiderations = guest.$mtcAllergens.join(', ')
          }
        }
      });
      if (this.guests.length > 0) {
        this.guests[0].$mtcIsSelected = true;
      }
      this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;
    }
  }

  back() {
    // this.personalPreferenceService.commitConsiderationsChanges(this.guests);
    if (!this.attendee.$mtcHasGuestsAttending) {
      this.registrationService.removeGuests(this.guests);
    }
    this.navigationService.back();
  }

  isItemSelected(item) {
    return item.$mtcIsSelected;
  }

  /**
   * @function areAnyGuestsSelected
   */
  areAnyGuestsSelected() {
    return _.some(this.guests, this.isItemSelected);
  }

  /**
   * @function isRemoveGuestEnabled
   * @description Checks if guest removal is enabled on a guest.
   */
  isRemoveGuestEnabled() {
    let filtered = _.filter(this.guests,  (guest) => {
      return !guest.$mtcDeleting;
    });
    return filtered.length > 1;
  }

  /**
   * @function removeGuest
   * @description Removes a guest from the using [RegistrationService.removeGuests()](./app.RegistrationService.html)
   */
  removeGuest(guest) {
    this.isDeleting = true;
    setTimeout(() => {
      this.isDeleting = false;
    }, 500);
    this.toBeDeleted = guest;
    _.remove(this.guests, guest);
    //_.remove(this.forms, guest);
    this.registrationService.removeGuests(guest);
    let last = _.last(this.guests);
    this.selectGuest(last === guest ? this.guests[this.guests.length - 1] : last);
    if(this.isRegComplete){
      for (const key of _.keys(this.charges)) {
            this.lineItemService.getLineItemsGuest(key).subscribe({
              next: data => {
                this.charges[key] = _.reduce(data, (sum, n) => {
                  return parseFloat(sum) + parseFloat(n);
                });
                },
                  error: error => {
                    this.constantsService.ALERT_POLICY.CONTACT_SUPPORT
                  }
            });
          }
      }
  }

  openContact(){
    this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
  }

}
